import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class MonthlyReportTagSettingProvider extends HttpRequest {
  getReports (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/monthly-report-tag-settings', query)
  }

  getStats () {
    this.setHeader(getAuthToken())
    return this.get('/monthly-report-tag-settings/stats')
  }

  getTagSuggestions () {
    this.setHeader(getAuthToken())
    return this.get('/monthly-report-tag-settings/tag-suggestions')
  }

  getReportById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/monthly-report-tag-settings/${id}`)
  }

  createReport (payload) {
    this.setHeader(getAuthToken())
    return this.post('/monthly-report-tag-settings', payload)
  }

  updateReport (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/monthly-report-tag-settings/${id}`, payload)
  }

  toggleReport (id, payload = {}) {
    this.setHeader(getAuthToken())
    return this.patch(`/monthly-report-tag-settings/${id}/toggle`, payload)
  }

  deleteReport (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/monthly-report-tag-settings/${id}`)
  }
}

export default MonthlyReportTagSettingProvider
